// SPDX-License-Identifier: LicenseRef-Proprietary

/**
 * Configuration constants for EvidenceDrawer component
 */
export const CLOSE_ANIMATION_DURATION_MS = 250;
export const SEARCH_DEBOUNCE_DELAY_MS = 500;
export const MIN_SEARCH_QUERY_LENGTH = 2;

